export default __webpack_public_path__ + "2025 Ultracold long-range van der Waals Rydberg trimers.pdf";